import { render, staticRenderFns } from "./my-issue-bus.vue?vue&type=template&id=6a1e2916&scoped=true&"
import script from "./my-issue-bus.vue?vue&type=script&lang=js&"
export * from "./my-issue-bus.vue?vue&type=script&lang=js&"
import style0 from "./my-issue-bus.vue?vue&type=style&index=0&id=6a1e2916&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1e2916",
  null
  
)

export default component.exports